module.exports = __webpack_public_path__ + "img/chickenmix.db1b13af.jpg";